import {
    UPDATE_SEARCH_PARAMS_REQUEST,
    RESET_SEARCH_PARAMS_REQUEST,
    SEARCH_CONFIG_REQUEST, 
    SEARCH_CONFIG_SUCCESS, 
    SEARCH_CONFIG_FAILURE,
    AUTOCOMPLETE_REQUEST, 
    AUTOCOMPLETE_SUCCESS, 
    AUTOCOMPLETE_FAILURE,
    SEARCH_SORT_OPTIONS_REQUEST, 
    SEARCH_SORT_OPTIONS_SUCCESS, 
    SEARCH_SORT_OPTIONS_FAILURE

} from '../actions/search';

const defaultSearchFilters = {
    /* SaleOrLease: {
        forSale: true,
        forRent: false
    }, */
    Criteria: {
        forSale: true,
        forRent: false,
        propertyType: ["House", "Condo"], 
        status: "Active"
    }    
};

export default (state = {
    
    filters: Object.assign({}, defaultSearchFilters),
    isConfigFetching: false,
    searchConfig: {},
    isAutoCompleteLoading: false,
    autoCompleteQuery: "",
    autoCompleteSuggestions: [],
    isSortOptionsFetching: false,
    sortOptions: ["Newest"]

}, action) => {

  switch (action.type) {
    case UPDATE_SEARCH_PARAMS_REQUEST:
        return {
            ...state,            
            lastFilters : Object.assign({}, state.filters),
            //filters: Object.assign({}, defaultSearchFilters, action.filters)
            filters: Object.assign({}, action.filters)
        };
    case RESET_SEARCH_PARAMS_REQUEST:
        return {
            ...state,
            lastFilters : Object.assign({}, state.filters),
            filters: Object.assign({}, defaultSearchFilters),
        };
    case SEARCH_CONFIG_REQUEST:
        return {
            ...state,
            isConfigFetching: true,
            error: undefined
        };
    case SEARCH_CONFIG_SUCCESS:
        return {
            ...state,
            isConfigFetching: false, 
            searchConfig: action.response,
            error: undefined
        };
    case SEARCH_CONFIG_FAILURE:
        return {
            ...state,
            isConfigFetching: false,
            error: action.error
        };
    case AUTOCOMPLETE_REQUEST:
        return {
            ...state,
            isAutoCompleteLoading: true,
            autoCompleteQuery: "",
            error: undefined
        };
    case AUTOCOMPLETE_SUCCESS:
        return {
            ...state,
            isAutoCompleteLoading: false, 
            autoCompleteQuery: action.query,
            autoCompleteSuggestions: action.response.Cities,
            error: undefined
        };
    case AUTOCOMPLETE_FAILURE:
        return {
            ...state,
            isAutoCompleteLoading: false,
            error: action.error
        };
    case SEARCH_SORT_OPTIONS_REQUEST:
        return {
            ...state,
            isSortOptionsFetching: true,
            error: undefined
        };
    case SEARCH_SORT_OPTIONS_SUCCESS:
        return {
            ...state,
            isSortOptionsFetching: false, 
            sortOptions: action.response,
            error: undefined
        };
    case SEARCH_SORT_OPTIONS_FAILURE:
        return {
            ...state,
            isSortOptionsFetching: false,
            error: action.error
        };
    default:
        return state;
  }

};
  
  